<template>
    <div id="dashboard-guests-view">
        <span class="dashboard-title mb-5">Guests</span>
        <span class="dashboard-subtitle mb-4">Manage guests for "{{ account.organization.name }}" organisation</span>

        <v-tabs background-color="#181818" dark height="40" slider-color="var(--primary)" slider-size="3">
            <v-tab class="ml-n4 mr-15 text-capitalize color-gray">Guests</v-tab>
            <v-tab class="mr-15 text-capitalize color-gray">Add Guests</v-tab>
            <v-tab class="text-capitalize color-gray">Pending Invitations</v-tab>

            <v-tab-item>
                <UsersList :list="activeGuests" />
            </v-tab-item>

            <v-tab-item>
                <AddGuests />
            </v-tab-item>

            <v-tab-item>
                <ManageInvitations :usersList="pendingGuests" />
            </v-tab-item>

        </v-tabs>

    </div>
</template>

<script>
import UsersList from "@/components/account/users/List";
import AddGuests from "@/components/account/guests/Add";
import ManageInvitations from '@/components/account/invitations/Manage';
import { mapGetters, mapState } from "vuex";

export default {
    name: "GuestsView",
    components: {
        UsersList,
        AddGuests,
        ManageInvitations,
    },

    async created() {
        this.$store.dispatch("Organizations/fetchPendingUsers");
        this.$store.dispatch("User/fetchCurrentPlan");
        this.$store.dispatch("Organizations/fetchUsers");
    },

    computed: {
        ...mapGetters('Organizations', ['pendingGuests', 'activeGuests']),
        ...mapState("User", ["account"]),
    },
}
</script>